import api from '@/apis/pa/pAGLPayrollExpenseSalaryAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('approveGLPayrollExpenseTab', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_salary',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
